const getFullName = ({ first_name, mi, last_name }) => {
  return `${first_name}${mi ? ` ${mi}` : ''}${
    last_name ? ` ${last_name}` : ''
  }`;
};

export { getFullName };
